import React from 'react';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
import { CandidatesTabsEnum } from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
interface Props {
	tab: CandidatesTabsEnum;
	setTab: (arg: CandidatesTabsEnum) => void;
	totalConections: number;
	onChange?: (value: CandidatesTabsEnum) => void;
	isTourActive: boolean;
}

const CampusCandidateListingTabs = ({ isTourActive, tab, setTab, totalConections, onChange }: Props) => {
	const location = useLocation();
	return (
		<>
			<div className="flex w-full whitespace-pre md:max-w-[500px] dark:bg-[#1F2A37]">
				<button
					className={`walkthrough-first-element ${
						tab === CandidatesTabsEnum.RECOMMENDATIONS
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_active',
							eventLabel: location.pathname,
						});
						setTab(CandidatesTabsEnum.RECOMMENDATIONS);
						onChange && onChange(CandidatesTabsEnum.RECOMMENDATIONS);
					}}
				>
					All Candidates
				</button>
				<button
					className={`walkthrough-second-element ${
						tab === CandidatesTabsEnum.CONNECTED
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-0 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						if (isTourActive) {
							return;
						}
						sendTrackingEvent({
							event: 'recr_dashboard_closed',
							eventLabel: location.pathname,
						});
						setTab(CandidatesTabsEnum.CONNECTED);
						onChange && onChange(CandidatesTabsEnum.CONNECTED);
					}}
				>
					Shortlisted Candidates {`(${totalConections})`}
				</button>
			</div>
		</>
	);
};

export default CampusCandidateListingTabs;
